export function AdminStatCard({ title, value, icon, color }) {
  return (
    <div className={`stat-card ${color}`}>
      <div>
        <p className="stat-title">{title}</p>
        <h3 className="stat-value">{value ?? "-"}</h3>
      </div>
      <i className={`bi bi-${icon}`}></i>
    </div>
  );
}
